import axios from "axios";
import { api } from "~/router/apiConfig";

export function index(contractId) {
  return axios.post(
    api.path("contractSpendingMonthly.index", {
      contractId
    })
  );
}
